import $ from 'jquery';
import { search } from './search';
import { isTutorRoute, isTutorLessonRoute } from '../routes';

const tutorLessonTagSelector = '.tutor-lesson-tag';
const tutorLessonTagRestSelector = '.tutor-lesson-tag-rest';
const tagInputSelector = 'input[name="LessonListSearchForm[tagsValue]"]';
const moreButtonSelector = '.tutor-lesson-tag-cloud-more-button';
const lessButtonSelector = '.tutor-lesson-tag-cloud-less-button';
const tagHiddenClass = 'tag-hidden';
const animated = 'animated';
const collapsed = 'collapsed';
const expanded = 'expanded';
const dataTagId = 'data-tag-id';
const active = 'active';

const moreButtonClickHandler = e => {
    const $target = $(e.target);
    const $rest = $(tutorLessonTagRestSelector);
    const $lessButton = $(lessButtonSelector);

    $lessButton.removeClass(tagHiddenClass);
    $lessButton.addClass(animated);
    $lessButton.addClass(expanded);

    $rest.removeClass(collapsed);
    $rest.addClass(animated);
    $rest.addClass(expanded);
    $target.removeClass(collapsed);
    $target.addClass(animated);
    $target.addClass(expanded);

    $rest.removeClass(tagHiddenClass);
    $target.addClass(tagHiddenClass);

    const restList = document.querySelectorAll(tutorLessonTagRestSelector);

    restList.forEach(element => {
        element.addEventListener('animationend', () => {
            $rest.removeClass(animated);
            $target.removeClass(animated);
            $target.addClass(tagHiddenClass);
        }, { once: true });
    });
}

const lessButtonClickHandler = e => {
    const $target = $(e.target);
    const $rest = $(tutorLessonTagRestSelector);

    $rest.addClass(animated);
    $rest.addClass(collapsed);
    $rest.removeClass(expanded);
    $target.addClass(animated);
    $target.addClass(collapsed);
    $target.removeClass(expanded);
    $(moreButtonSelector).addClass(collapsed);
    $(moreButtonSelector).addClass(animated);
    $(moreButtonSelector).removeClass(tagHiddenClass);

    const restList = document.querySelectorAll(tutorLessonTagRestSelector);

    restList.forEach(element => {
        element.addEventListener('animationend', () => {
            $rest.removeClass(animated);
            $rest.addClass(tagHiddenClass);
            $target.removeClass(animated);
            $target.addClass(tagHiddenClass);
        }, { once: true });
    });
}

const setInputValue = ($input, tagIdList) => {
    $input.val(tagIdList.join(','));
    search();
}

const getTagIdList = $input => $input.val() ? $input.val().split(',') : [];

const updateTagsValue = (tag) => {
    const $input = $(tag).parent().children('input');
    const tagId = $(tag).attr(dataTagId);
    const tagIdList = getTagIdList($input);

    if ($(tag).hasClass(active) && !tagIdList.includes(tagId)) {
        return;
    }

    if ($(tag).hasClass(active)) {
        setInputValue(
            $input,
            tagIdList.filter(
                currentTagId => currentTagId !== tagId,
            ),
        );

        return;
    }

    if (tagIdList.includes(tagId)) {
        return;
    }

    tagIdList.push(tagId);
    setInputValue($input, tagIdList);
}

const tutorLessonTagClickHandler = function () {
    updateTagsValue(this);

    if ($(this).hasClass(active)) {
        $(this).removeClass(active);

        return;
    }

    $(this).addClass(active);
}

const initActiveTags = () => {
    const tagIdList = getTagIdList($(tagInputSelector));

    tagIdList.forEach(tagId => {
        const $tag = $(tutorLessonTagSelector + `[data-tag-id="${tagId}"]`);

        if (!$tag.length) {
            return;
        }

        $tag.addClass(active);
    });
}

export const tutorTagCloudHandlers = () => {
    if (!isTutorRoute) {
        return;
    }

    if (isTutorLessonRoute) {
        return;
    }

    initActiveTags();

    $(moreButtonSelector).on('click', moreButtonClickHandler);
    $(lessButtonSelector).on('click', lessButtonClickHandler);
    $(tutorLessonTagSelector).on('click', tutorLessonTagClickHandler);
};
